export const buildContractItemUniquenessCombination = (contractItem) => {
  return {
    product: contractItem?.product,
    carrier: contractItem?.carrier,
    destination: contractItem?.destination,
    serviceType: contractItem?.serviceType
  }
}
